__webpack_require__.p = "https://ui.cltp.co/akaashpath-flyin/_next/";